import { useState } from "react";

import HatIcon from "../../assets/images/hat-icon.png";
import MonitorIcon from "../../assets/images/monitor-icon.png";
import CamIcon from "../../assets/images/cam-icon.png";
import BrainIcon from "../../assets/images/brain-icon.png";
import CartIcon from "../../assets/images/cart-icon.png";
import UsersIcon from "../../assets/images/users-icon.png";
import WhoCanApplyBg from "../../assets/images/faq-bg.png";
import RedBox3 from "../../assets/images/red-box-3.png";

const WhoCanApply = (props) => {
  const [conditions] = useState([
    {
      icon: HatIcon,
      engtext: "3rd, 4th year, master 1st year and new graduates",
      trtext: "3, 4. sınıf lisans, 1. sınıf yüksek lisans ve yeni mezunlar",
    },
    {
      icon: MonitorIcon,
      engtext: "Who want to work in the digital industry",
      trtext: "Dijital sektörde çalışmak isteyenler",
    },
    {
      icon: CamIcon,
      engtext: "Available on May 11 for online Day 1",
      trtext: "Online 1. gün için 11 Mayıs’ta müsait olmak",
    },
    {
      icon: BrainIcon,
      engtext: "Passionate about digital world",
      trtext: "Dijital dünya hakkında tutkulu",
    },
    {
      icon: CartIcon,
      engtext: "Interested into FMCG industry",
      trtext: "FMCG endüstrisine ilgi duyan",
    },
    {
      icon: UsersIcon,
      engtext: "Available on May 12 online for Day 2",
      trtext: "Online 2. gün için 12 Mayıs’ta müsait olmak.",
    },
  ]);

  return (
    <section
      id={props.currentLang === "eng" ? "who-can-apply" : "kimler-basvurabilir"}
      className="w-full flex justify-center bg-[#FFC000] py-28 relative"
    >
      <div className="w-4/5 max-w-screen-xl z-[1]">
        <div>
          <h2
            data-aos="fade-down"
            className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-white font-bold text-center"
          >
            {props.currentLang === "eng"
              ? "WHO CAN APPLY?"
              : "KİMLER BAŞVURABİLİR?"}
          </h2>
          <div className="flex flex-wrap">
            {conditions.map((item, index) => {
              return (
                <div
                  data-aos="fade-up"
                  key={index}
                  className="w-full md:w-1/2 lg:w-1/2 xl:w-1/3 flex flex-row px-3 py-5 space-x-5"
                >
                  <img
                    className="w-[70px] lg:w-[88px] object-center object-contain"
                    src={item.icon}
                    alt={
                      props.currentLang === "eng" ? item.engtext : item.trtext
                    }
                  />
                  <p className="text-[#1F36C7] text-base md:text-xl lg:text-2xl font-bold flex items-center">
                    {props.currentLang === "eng" ? item.engtext : item.trtext}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <img
        className="absolute w-3/5 -top-[50px] sm:-top-[90px] md:-top-[120px] lg:-top-[150px] xl:-top-[190px] right-0"
        src={WhoCanApplyBg}
        alt="who can apply background"
      />
      <img
        className="absolute w-[150px] md:w-[270px] -top-20 md:-top-32 right-14 z-[2]"
        src={RedBox3}
        alt="red box"
      />
    </section>
  );
};

export default WhoCanApply;
